import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import useDebounce from 'hook/useDebounce';
import { forwardRef, useEffect, useState, useRef, Fragment } from 'react';
import getAddress from 'api/getAddress';

export const AutoCompleteDistrict = forwardRef(
  ({ name, value, onChange, onBlur, placeholder, onCommit, error }, ref) => {
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);

    // const [selValue, setSelValue] = useState(null);
    const [inputValue, setInputValue] = useState(value);
    const debounceValue = useDebounce(inputValue, 500);
    const loading = useRef(false);

    const errorProps = error ? { sx: { borderColor: 'red' } } : undefined;

    useEffect(() => {
      let active = true;

      if (debounceValue) {
        loading.current = true;
        (async () => {
          // await sleep(1e3); // For demo purposes.
          const regex = /(^ตำบล|^แขวง|^เขต|^อำเภอ)/i;
          const keyword = debounceValue.replace(regex, '');
          getAddress(keyword)
            .then((data) => {
              loading.current = false;
              // console.log(res.data);
              if (active && data.length) {
                setOptions([...data]);
              }
            })
            .catch(console.error);
        })();
      }

      return () => {
        active = false;
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debounceValue]);

    const onOpen = () => {
      setOpen(true);
    };
    const onClose = () => {
      setOpen(false);
    };

    return (
      <Autocomplete
        // value={selValue}
        onChange={(_, value) => {
          if (value?._id) {
            const curr = options.find((x) => x._id === value._id);
            console.log(curr);
            onCommit(curr);
          }
        }}
        freeSolo
        inputValue={inputValue}
        onInputChange={(_, value) => {
          setInputValue(value);
          onChange(value);
        }}
        open={open}
        onOpen={onOpen}
        onClose={onClose}
        isOptionEqualToValue={(option, value) => option._id === value._id}
        getOptionLabel={(option) => option.district}
        options={options}
        loading={loading.current}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option._id}>
              {`${option.district} - (${option.province})`}
            </li>
          );
        }}
        renderInput={(params) => (
          <TextField
            placeholder={placeholder}
            size="large"
            {...params}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <Fragment>
                  {loading.current ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </Fragment>
              ),
              ...errorProps,
            }}
          />
        )}
      />
    );
  }
);
